import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import {
    AutoRefreshTokenService,
    INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
    includeBearerTokenInterceptor,
    provideKeycloak,
    UserActivityService,
    withAutoRefreshToken
} from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { bearerTokenConditions } from './core/interceptors/bearer-token.config';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { OrangePreset } from './core/theme/orange.preset';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([includeBearerTokenInterceptor, errorInterceptor])),
        { provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, useValue: bearerTokenConditions },
        provideKeycloak({
            config: environment.keycloak,
            initOptions: {
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
            },
            features: [
                withAutoRefreshToken({ onInactivityTimeout: 'logout', sessionTimeout: 1800000 })
            ],
            providers: [AutoRefreshTokenService, UserActivityService]
        }),
        MessageService,
        providePrimeNG({
            license: environment.primeNgLicense,
            theme: {
                preset: OrangePreset,
                options: {
                    darkModeSelector: '.app-dark'
                }
            },
            ripple: true
        })
    ]
};
